import { useTranslation } from 'react-i18next';

function LanguageSwitcher() {
  const { t, i18n } = useTranslation();

  const languages = [
    {
      code: 'pl',
      labelKey: 'languages.polish',
      shortLabel: 'PL',
      flag: '🇵🇱',
    },
    {
      code: 'en',
      labelKey: 'languages.english',
      shortLabel: 'EN',
      flag: '🇬🇧',
    },
    {
      code: 'fr',
      labelKey: 'languages.french',
      shortLabel: 'FR',
      flag: '🇫🇷',
    },
  ];

  const activeLanguage = i18n.resolvedLanguage || i18n.language;

  return (
    <div className="language-switcher" aria-label={t('languages.aria')}>
      {languages.map((language) => {
        const label = t(language.labelKey);

        return (
          <button
            type="button"
            key={language.code}
            className={`language-option ${activeLanguage === language.code ? 'active' : ''}`}
            onClick={() => i18n.changeLanguage(language.code)}
            aria-label={t('languages.changeTo', { language: label })}
            title={label}
          >
            <span className="language-flag" aria-hidden="true">
              {language.flag}
            </span>
            <span className="language-code">{language.shortLabel}</span>
          </button>
        );
      })}
    </div>
  );
}

export default LanguageSwitcher;
